import { render, staticRenderFns } from "./FormV2.vue?vue&type=template&id=0773443a&scoped=true&"
import script from "./FormV2.vue?vue&type=script&lang=js&"
export * from "./FormV2.vue?vue&type=script&lang=js&"
import style0 from "./FormV2.vue?vue&type=style&index=0&id=0773443a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0773443a",
  null
  
)

export default component.exports